import {
  FAQS,
  FOOTER_LINKS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import OrderSummaryBackground from "public/images/swbrailriders/OrderSummary.jpg";

export const swbrailriders_pass: TTeamConfig = {
  TEAM_SCHEMA: "swbrailriders_pass",
  TEAM_FULL_NAME: "Scranton Wilkies-Barre RailRiders",
  BROWSER_TITLE: "RailRiders All-Access Pass",
  CLIENT_ID: "1541d92591f7.seasonshare.swbyankees-dbh.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002c5d",
    COLORS_SECONDARY: "#960530",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/swbyankees/",
    IS_INTERCOM_ENABLED: true,
    ANALYTICS_HEADER: AnalyticsHeader,

    FOOTER: {
      LINKS: FOOTER_LINKS,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#960530",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackground.src,
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/swb-railriders-rrail-logo.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
